import { Link } from '@tanstack/react-router';
import { Trophy, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function ReportsIndexPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Reports</h1>
        <p className="text-muted-foreground">Analytics and insights for your team.</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <Link to="/reports/leaderboard">
          <Card className="cursor-pointer transition-shadow hover:shadow-md">
            <CardHeader>
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-amber-100 text-amber-600 dark:bg-amber-900/20">
                  <Trophy className="h-5 w-5" />
                </div>
                <div>
                  <CardTitle>Leaderboard</CardTitle>
                  <CardDescription>Team rankings by revenue and deals won.</CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                See who is leading the team in closed revenue, number of deals, and pipeline value.
              </p>
            </CardContent>
          </Card>
        </Link>

        <Card className="opacity-60">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100 text-blue-600 dark:bg-blue-900/20">
                <TrendingUp className="h-5 w-5" />
              </div>
              <div>
                <CardTitle>Revenue Report</CardTitle>
                <CardDescription>Detailed revenue analytics.</CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Coming soon. Monthly and quarterly revenue breakdowns with trends.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
